export { default } from './AppNotificationView';



// WEBPACK FOOTER //
// ./src/components/views/AppNotificationView/index.js